<template>
  <div class="footer d-flex justify-content-center">
    <div class="mx-3 mt-1">
      <a :href="'https://wa.me/'+telefono" target="_blank">
        <img src="@/assets/whatsapp.png" style="height: 40px; cursor: pointer;" />
      </a>        
    </div>
    <div class="mx-3 mt-1">
      <a href="https://www.instagram.com/refugio.naposta/" target="_blank">
        <img src="@/assets/instagram.png" style="height: 40px; cursor: pointer;" />
      </a>      
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: 'ComponentFooter',
  mounted() {
    this.variableGetByName('telefono');
  },
  data() {
    return {
      telefono: ''
    };
  },
  methods: {
    ...mapActions('variable', ['variable_getByName']),
    async variableGetByName(nombre) {
      try {
        let response = await this.variable_getByName({ nombre: nombre });

        if (response.status == 200) {
          this[nombre] = response.data.value;
        }
      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo variable');
      }
    }
  },

};
</script>

<style scoped>
.footer {
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100vw;
  background: rgba(25, 25, 25);
  z-index: 20;
}

</style>
